import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";
import { getAddress } from "../address/index.js";
import { keccak256 } from "../crypto/index.js";
import { recoverAddress } from "../transaction/index.js";
import { concat, defineProperties, getBigInt, getBytes, hexlify, isHexString, mask, toBeHex, toQuantity, toTwos, zeroPadValue, assertArgument } from "../utils/index.js";
import { id } from "./id.js";
var padding = new Uint8Array(32);
padding.fill(0);
var BN__1 = BigInt(-1);
var BN_0 = BigInt(0);
var BN_1 = BigInt(1);
var BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
;
;
function hexPadRight(value) {
  var bytes = getBytes(value);
  var padOffset = bytes.length % 32;
  if (padOffset) {
    return concat([bytes, padding.slice(padOffset)]);
  }
  return hexlify(bytes);
}
var hexTrue = toBeHex(BN_1, 32);
var hexFalse = toBeHex(BN_0, 32);
var domainFieldTypes = {
  name: "string",
  version: "string",
  chainId: "uint256",
  verifyingContract: "address",
  salt: "bytes32"
};
var domainFieldNames = ["name", "version", "chainId", "verifyingContract", "salt"];
function checkString(key) {
  return function (value) {
    assertArgument(typeof value === "string", "invalid domain value for ".concat(JSON.stringify(key)), "domain.".concat(key), value);
    return value;
  };
}
var domainChecks = {
  name: checkString("name"),
  version: checkString("version"),
  chainId: function chainId(_value) {
    var value = getBigInt(_value, "domain.chainId");
    assertArgument(value >= 0, "invalid chain ID", "domain.chainId", _value);
    if (Number.isSafeInteger(value)) {
      return Number(value);
    }
    return toQuantity(value);
  },
  verifyingContract: function verifyingContract(value) {
    try {
      return getAddress(value).toLowerCase();
    } catch (error) {}
    assertArgument(false, "invalid domain value \"verifyingContract\"", "domain.verifyingContract", value);
  },
  salt: function salt(value) {
    var bytes = getBytes(value, "domain.salt");
    assertArgument(bytes.length === 32, "invalid domain value \"salt\"", "domain.salt", value);
    return hexlify(bytes);
  }
};
function getBaseEncoder(type) {
  // intXX and uintXX
  {
    var match = type.match(/^(u?)int(\d*)$/);
    if (match) {
      var signed = match[1] === "";
      var width = parseInt(match[2] || "256");
      assertArgument(width % 8 === 0 && width !== 0 && width <= 256 && (match[2] == null || match[2] === String(width)), "invalid numeric width", "type", type);
      var boundsUpper = mask(BN_MAX_UINT256, signed ? width - 1 : width);
      var boundsLower = signed ? (boundsUpper + BN_1) * BN__1 : BN_0;
      return function (_value) {
        var value = getBigInt(_value, "value");
        assertArgument(value >= boundsLower && value <= boundsUpper, "value out-of-bounds for ".concat(type), "value", value);
        return toBeHex(signed ? toTwos(value, 256) : value, 32);
      };
    }
  }
  // bytesXX
  {
    var _match = type.match(/^bytes(\d+)$/);
    if (_match) {
      var _width = parseInt(_match[1]);
      assertArgument(_width !== 0 && _width <= 32 && _match[1] === String(_width), "invalid bytes width", "type", type);
      return function (value) {
        var bytes = getBytes(value);
        assertArgument(bytes.length === _width, "invalid length for ".concat(type), "value", value);
        return hexPadRight(value);
      };
    }
  }
  switch (type) {
    case "address":
      return function (value) {
        return zeroPadValue(getAddress(value), 32);
      };
    case "bool":
      return function (value) {
        return !value ? hexFalse : hexTrue;
      };
    case "bytes":
      return function (value) {
        return keccak256(value);
      };
    case "string":
      return function (value) {
        return id(value);
      };
  }
  return null;
}
function encodeType(name, fields) {
  return "".concat(name, "(").concat(fields.map(function (_ref) {
    var name = _ref.name,
      type = _ref.type;
    return type + " " + name;
  }).join(","), ")");
}
/**
 *  A **TypedDataEncode** prepares and encodes [[link-eip-712]] payloads
 *  for signed typed data.
 *
 *  This is useful for those that wish to compute various components of a
 *  typed data hash, primary types, or sub-components, but generally the
 *  higher level [[Signer-signTypedData]] is more useful.
 */
var _types = /*#__PURE__*/new WeakMap();
var _fullTypes = /*#__PURE__*/new WeakMap();
var _encoderCache = /*#__PURE__*/new WeakMap();
var _getEncoder = /*#__PURE__*/new WeakSet();
export var TypedDataEncoder = /*#__PURE__*/function () {
  /**
   *  Create a new **TypedDataEncoder** for %%types%%.
   *
   *  This performs all necessary checking that types are valid and
   *  do not violate the [[link-eip-712]] structural constraints as
   *  well as computes the [[primaryType]].
   */
  function TypedDataEncoder(types) {
    _classCallCheck(this, TypedDataEncoder);
    _classPrivateMethodInitSpec(this, _getEncoder);
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */
    _defineProperty(this, "primaryType", void 0);
    _classPrivateFieldInitSpec(this, _types, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _fullTypes, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _encoderCache, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _types, JSON.stringify(types));
    _classPrivateFieldSet(this, _fullTypes, new Map());
    _classPrivateFieldSet(this, _encoderCache, new Map());
    // Link struct types to their direct child structs
    var links = new Map();
    // Link structs to structs which contain them as a child
    var parents = new Map();
    // Link all subtypes within a given struct
    var subtypes = new Map();
    Object.keys(types).forEach(function (type) {
      links.set(type, new Set());
      parents.set(type, []);
      subtypes.set(type, new Set());
    });
    for (var name in types) {
      var uniqueNames = new Set();
      var _iterator = _createForOfIteratorHelper(types[name]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;
          // Check each field has a unique name
          assertArgument(!uniqueNames.has(field.name), "duplicate variable name ".concat(JSON.stringify(field.name), " in ").concat(JSON.stringify(name)), "types", types);
          uniqueNames.add(field.name);
          // Get the base type (drop any array specifiers)
          var baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1] || null;
          assertArgument(baseType !== name, "circular type reference to ".concat(JSON.stringify(baseType)), "types", types);
          // Is this a base encoding type?
          var encoder = getBaseEncoder(baseType);
          if (encoder) {
            continue;
          }
          assertArgument(parents.has(baseType), "unknown type ".concat(JSON.stringify(baseType)), "types", types);
          // Add linkage
          parents.get(baseType).push(name);
          links.get(name).add(baseType);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    // Deduce the primary type
    var primaryTypes = Array.from(parents.keys()).filter(function (n) {
      return parents.get(n).length === 0;
    });
    assertArgument(primaryTypes.length !== 0, "missing primary type", "types", types);
    assertArgument(primaryTypes.length === 1, "ambiguous primary types or unused types: ".concat(primaryTypes.map(function (t) {
      return JSON.stringify(t);
    }).join(", ")), "types", types);
    defineProperties(this, {
      primaryType: primaryTypes[0]
    });
    // Check for circular type references
    function checkCircular(type, found) {
      assertArgument(!found.has(type), "circular type reference to ".concat(JSON.stringify(type)), "types", types);
      found.add(type);
      var _iterator2 = _createForOfIteratorHelper(links.get(type)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          if (!parents.has(child)) {
            continue;
          }
          // Recursively check children
          checkCircular(child, found);
          // Mark all ancestors as having this decendant
          var _iterator3 = _createForOfIteratorHelper(found),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var subtype = _step3.value;
              subtypes.get(subtype).add(child);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      found.delete(type);
    }
    checkCircular(this.primaryType, new Set());
    // Compute each fully describe type
    var _iterator4 = _createForOfIteratorHelper(subtypes),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _step4$value = _slicedToArray(_step4.value, 2),
          _name = _step4$value[0],
          set = _step4$value[1];
        var st = Array.from(set);
        st.sort();
        _classPrivateFieldGet(this, _fullTypes).set(_name, encodeType(_name, types[_name]) + st.map(function (t) {
          return encodeType(t, types[t]);
        }).join(""));
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  /**
   *  Returnthe encoder for the specific %%type%%.
   */
  _createClass(TypedDataEncoder, [{
    key: "types",
    get:
    /**
     *  The types.
     */
    function get() {
      return JSON.parse(_classPrivateFieldGet(this, _types));
    }
  }, {
    key: "getEncoder",
    value: function getEncoder(type) {
      var encoder = _classPrivateFieldGet(this, _encoderCache).get(type);
      if (!encoder) {
        encoder = _classPrivateMethodGet(this, _getEncoder, _getEncoder2).call(this, type);
        _classPrivateFieldGet(this, _encoderCache).set(type, encoder);
      }
      return encoder;
    }
  }, {
    key: "encodeType",
    value:
    /**
     *  Return the full type for %%name%%.
     */
    function encodeType(name) {
      var result = _classPrivateFieldGet(this, _fullTypes).get(name);
      assertArgument(result, "unknown type: ".concat(JSON.stringify(name)), "name", name);
      return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */
  }, {
    key: "encodeData",
    value: function encodeData(type, value) {
      return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */
  }, {
    key: "hashStruct",
    value: function hashStruct(name, value) {
      return keccak256(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */
  }, {
    key: "encode",
    value: function encode(value) {
      return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */
  }, {
    key: "hash",
    value: function hash(value) {
      return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */
  }, {
    key: "_visit",
    value: function _visit(type, value, callback) {
      var _this = this;
      // Basic encoder type (address, bool, uint256, etc)
      {
        var encoder = getBaseEncoder(type);
        if (encoder) {
          return callback(type, value);
        }
      }
      // Array
      var match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
      if (match) {
        assertArgument(!match[3] || parseInt(match[3]) === value.length, "array length mismatch; expected length ".concat(parseInt(match[3])), "value", value);
        return value.map(function (v) {
          return _this._visit(match[1], v, callback);
        });
      }
      // Struct
      var fields = this.types[type];
      if (fields) {
        return fields.reduce(function (accum, _ref2) {
          var name = _ref2.name,
            type = _ref2.type;
          accum[name] = _this._visit(type, value[name], callback);
          return accum;
        }, {});
      }
      assertArgument(false, "unknown type: ".concat(type), "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */
  }, {
    key: "visit",
    value: function visit(value, callback) {
      return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */
  }], [{
    key: "from",
    value: function from(types) {
      return new TypedDataEncoder(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */
  }, {
    key: "getPrimaryType",
    value: function getPrimaryType(types) {
      return TypedDataEncoder.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */
  }, {
    key: "hashStruct",
    value: function hashStruct(name, types, value) {
      return TypedDataEncoder.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */
  }, {
    key: "hashDomain",
    value: function hashDomain(domain) {
      var domainFields = [];
      for (var name in domain) {
        if (domain[name] == null) {
          continue;
        }
        var type = domainFieldTypes[name];
        assertArgument(type, "invalid typed-data domain key: ".concat(JSON.stringify(name)), "domain", domain);
        domainFields.push({
          name: name,
          type: type
        });
      }
      domainFields.sort(function (a, b) {
        return domainFieldNames.indexOf(a.name) - domainFieldNames.indexOf(b.name);
      });
      return TypedDataEncoder.hashStruct("EIP712Domain", {
        EIP712Domain: domainFields
      }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */
  }, {
    key: "encode",
    value: function encode(domain, types, value) {
      return concat(["0x1901", TypedDataEncoder.hashDomain(domain), TypedDataEncoder.from(types).hash(value)]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */
  }, {
    key: "hash",
    value: function hash(domain, types, value) {
      return keccak256(TypedDataEncoder.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */
  }, {
    key: "resolveNames",
    value: function () {
      var _resolveNames = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domain, types, value, resolveName) {
        var key, ensCache, encoder, name;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Make a copy to isolate it from the object passed in
              domain = Object.assign({}, domain);
              // Allow passing null to ignore value
              for (key in domain) {
                if (domain[key] == null) {
                  delete domain[key];
                }
              }
              // Look up all ENS names
              ensCache = {}; // Do we need to look up the domain's verifyingContract?
              if (domain.verifyingContract && !isHexString(domain.verifyingContract, 20)) {
                ensCache[domain.verifyingContract] = "0x";
              }
              // We are going to use the encoder to visit all the base values
              encoder = TypedDataEncoder.from(types); // Get a list of all the addresses
              encoder.visit(value, function (type, value) {
                if (type === "address" && !isHexString(value, 20)) {
                  ensCache[value] = "0x";
                }
                return value;
              });
              // Lookup each name
              _context.t0 = _regeneratorRuntime.keys(ensCache);
            case 7:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 14;
                break;
              }
              name = _context.t1.value;
              _context.next = 11;
              return resolveName(name);
            case 11:
              ensCache[name] = _context.sent;
              _context.next = 7;
              break;
            case 14:
              // Replace the domain verifyingContract if needed
              if (domain.verifyingContract && ensCache[domain.verifyingContract]) {
                domain.verifyingContract = ensCache[domain.verifyingContract];
              }
              // Replace all ENS names with their address
              value = encoder.visit(value, function (type, value) {
                if (type === "address" && ensCache[value]) {
                  return ensCache[value];
                }
                return value;
              });
              return _context.abrupt("return", {
                domain: domain,
                value: value
              });
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function resolveNames(_x, _x2, _x3, _x4) {
        return _resolveNames.apply(this, arguments);
      }
      return resolveNames;
    }()
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */
  }, {
    key: "getPayload",
    value: function getPayload(domain, types, value) {
      // Validate the domain fields
      TypedDataEncoder.hashDomain(domain);
      // Derive the EIP712Domain Struct reference type
      var domainValues = {};
      var domainTypes = [];
      domainFieldNames.forEach(function (name) {
        var value = domain[name];
        if (value == null) {
          return;
        }
        domainValues[name] = domainChecks[name](value);
        domainTypes.push({
          name: name,
          type: domainFieldTypes[name]
        });
      });
      var encoder = TypedDataEncoder.from(types);
      var typesWithDomain = Object.assign({}, types);
      assertArgument(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
      typesWithDomain.EIP712Domain = domainTypes;
      // Validate the data structures and types
      encoder.encode(value);
      return {
        types: typesWithDomain,
        domain: domainValues,
        primaryType: encoder.primaryType,
        message: encoder.visit(value, function (type, value) {
          // bytes
          if (type.match(/^bytes(\d*)/)) {
            return hexlify(getBytes(value));
          }
          // uint or int
          if (type.match(/^u?int/)) {
            return getBigInt(value).toString();
          }
          switch (type) {
            case "address":
              return value.toLowerCase();
            case "bool":
              return !!value;
            case "string":
              assertArgument(typeof value === "string", "invalid string", "value", value);
              return value;
          }
          assertArgument(false, "unsupported type", "type", type);
        })
      };
    }
  }]);
  return TypedDataEncoder;
}();
/**
 *  Compute the address used to sign the typed data for the %%signature%%.
 */
function _getEncoder2(type) {
  var _this2 = this;
  // Basic encoder type (address, bool, uint256, etc)
  {
    var encoder = getBaseEncoder(type);
    if (encoder) {
      return encoder;
    }
  }
  // Array
  var match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
  if (match) {
    var subtype = match[1];
    var subEncoder = this.getEncoder(subtype);
    return function (value) {
      assertArgument(!match[3] || parseInt(match[3]) === value.length, "array length mismatch; expected length ".concat(parseInt(match[3])), "value", value);
      var result = value.map(subEncoder);
      if (_classPrivateFieldGet(_this2, _fullTypes).has(subtype)) {
        result = result.map(keccak256);
      }
      return keccak256(concat(result));
    };
  }
  // Struct
  var fields = this.types[type];
  if (fields) {
    var encodedType = id(_classPrivateFieldGet(this, _fullTypes).get(type));
    return function (value) {
      var values = fields.map(function (_ref3) {
        var name = _ref3.name,
          type = _ref3.type;
        var result = _this2.getEncoder(type)(value[name]);
        if (_classPrivateFieldGet(_this2, _fullTypes).has(type)) {
          return keccak256(result);
        }
        return result;
      });
      values.unshift(encodedType);
      return concat(values);
    };
  }
  assertArgument(false, "unknown type: ".concat(type), "type", type);
}
export function verifyTypedData(domain, types, value, signature) {
  return recoverAddress(TypedDataEncoder.hash(domain, types, value), signature);
}